import React from 'react';
import Banner from '../components/Banner';
import Scenarios from '../components/Scenarios';
import ProductRecommend from '../components/ProductRecommend';
import ActivityIntroduction from '../components/ActivityIntroduction';
import ProductList from '../components/ProductList';
import styles from './index.module.scss';
import { EcoProvider } from '@/components/EcoCredits/context';
import FooterTcA from '../components/FooterTcA';

const Delta3MaxSeriesA: React.FC = () => {
    return (
        <section className={styles.Delta3MaxSeriesA}>
            <Banner />
            <div className="d3m-wrap-1">
                <Scenarios />
                <ProductRecommend />
            </div>
            <div className="d3m-wrap-2">
                <div className="d3m-wrap-in-2">
                    <EcoProvider>
                        <ActivityIntroduction />
                    </EcoProvider>
                    <ProductList />
                </div>
            </div>
            <FooterTcA />
        </section>
    );
};

export default Delta3MaxSeriesA;
